import { render, staticRenderFns } from "./listJobCounseling.vue?vue&type=template&id=63f42956&"
import script from "./listJobCounseling.vue?vue&type=script&lang=js&"
export * from "./listJobCounseling.vue?vue&type=script&lang=js&"
import style0 from "./listJobCounseling.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports